var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tabs, Tab, Chip, Stack, Card, Rating, Grid, Tooltip, } from '@mui/material';
import { useEffect, useState, useCallback } from 'react';
import { Typography } from '../../utils/Typography';
import { ClientIcon, DeleteIcon, EmailIcon, MobileIcon, PhoneIcon, } from '../../utils/Icons';
import { Definitions } from '../../utils/Definitions';
import * as ServiceClient from '../../services/client';
import { Loader } from '../../utils/Loader';
import { Equipe } from '../equipe/Equipe';
import { CardTitle } from '../../utils/CardTitle';
import { EditionClient } from './EditionClient';
import { Contact } from '../contact/Contact';
import { Affaire } from '../affaire/Affaire';
import { Activite } from '../activite/Activite';
import { Button } from '../../utils/Button';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { Document } from '../document/Document';
import { TimelineVertical } from '../../utils/TimelineVertical';
import { MapData, MapRedirection } from '../../utils/MapData';
import { classChipInHeader, colorEtatClient } from '../../utils/Classes';
import { IconButton } from '../../utils/IconButton';
import { Snackbar } from '../../utils/Snackbar';
import { Error, isError } from '../error/Error';
import { getIsMobile, getOriginalUser } from '../../services/utilisateur';
import { ChartPie } from '../statistique/ChartPie';
import { TYPES_EQUIPE } from '../equipe/EditionEquipe';
var originalUser = getOriginalUser();
export var FicheClient = function (props) {
    var ClientId = props.ClientId;
    var isMobile = getIsMobile();
    var _a = useState(0), navigationSelected = _a[0], setNavigationSelected = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), client = _c[0], setClient = _c[1];
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var newClient;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceClient.getClient(ClientId)];
                case 1:
                    newClient = _a.sent();
                    setClient(newClient);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        getData();
    }, []);
    if (!client || loading) {
        return _jsx(Loader, {});
    }
    if (isError(client)) {
        return _jsx(Error, __assign({}, client));
    }
    var renderClient = function () {
        var adresse = [
            client.Adresse,
            client.CodePostal,
            client.Ville,
            client.intitule_pays ? client.intitule_pays.Libelle : '',
        ]
            .filter(function (value) { return value; })
            .join(' ');
        var recapitulatifs = client.Recapitulatif
            ? client.Recapitulatif.filter(function (recapitulatif) {
                return recapitulatif.Regroupement ===
                    TABS[navigationSelected].label.toLowerCase();
            })
            : [];
        return (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsxs(Grid, __assign({ container: true, spacing: isMobile ? 0 : 2, p: 1 }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, md: 4 }, { children: [client.IsSociete ? (_jsx(Definitions, { datas: [
                                    {
                                        label: 'Type',
                                        value: client.client_type && client.client_type.Libelle
                                            ? client.client_type.Libelle
                                            : '-',
                                    },
                                    { label: 'Siret', value: client.Siret },
                                    {
                                        label: 'Siège',
                                        value: (_jsx(Chip, { color: client.IsSiege ? 'primary' : 'default', label: client.IsSiege ? 'Oui' : 'Non' })),
                                    },
                                    {
                                        label: 'Code Naf-Ape',
                                        value: client.code_naf_ape
                                            ? client.code_naf_ape.getLibelle
                                            : '-',
                                    },
                                    {
                                        label: "Tranche d'éffectif",
                                        value: client.getTrancheEffectifLibelle,
                                    },
                                ] })) : (_jsx(Definitions, { datas: __spreadArray(__spreadArray(__spreadArray([], (client.Email
                                    ? [
                                        {
                                            value: (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Envoyer un mail", color: "primary", href: "mailto:".concat(client.Email) }, { children: _jsx(EmailIcon, {}) })) }, { children: client.Email }))),
                                        },
                                    ]
                                    : []), true), (client.Telephone
                                    ? [
                                        {
                                            value: (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Contacter ce num\u00E9ro fixe", color: "primary", href: "tel:".concat(client.Telephone) }, { children: _jsx(PhoneIcon, {}) })) }, { children: client.Telephone }))),
                                        },
                                    ]
                                    : []), true), (client.Mobile
                                    ? [
                                        {
                                            value: (_jsx(Typography, __assign({ startIcon: _jsx(IconButton, __assign({ tooltip: "Contacter ce num\u00E9ro mobile", color: "primary", href: "tel:".concat(client.Mobile) }, { children: _jsx(MobileIcon, {}) })) }, { children: client.Mobile }))),
                                        },
                                    ]
                                    : []), true) })), _jsx(Definitions, { datas: __spreadArray(__spreadArray(__spreadArray(__spreadArray([
                                    {
                                        label: client.IsSociete ? 'Adresse' : null,
                                        value: (_jsxs(Stack, __assign({ alignItems: "center", direction: "row" }, { children: [_jsx(MapRedirection, { queries: [adresse] }), adresse] }))),
                                    }
                                ], (client.Latitude && client.Longitude
                                    ? [
                                        {
                                            value: (_jsx("div", { children: _jsx(MapData, { libelle: adresse, Latitude: client.Latitude, Longitude: client.Longitude }) })),
                                        },
                                    ]
                                    : []), true), (client.TagsObject && client.TagsObject.length > 0
                                    ? [
                                        {
                                            value: (_jsx(Stack, __assign({ direction: isMobile ? 'column' : 'row', spacing: 2 }, { children: client.TagsObject.map(function (tag) { return (_jsx(Chip, { color: "info", label: tag.label }, tag.value)); }) }))),
                                        },
                                    ]
                                    : []), true), (client.Commentaire
                                    ? [
                                        {
                                            label: 'Commentaire',
                                            valueUnder: true,
                                            value: _jsx("p", __assign({ className: "pre-line" }, { children: client.Commentaire })),
                                        },
                                    ]
                                    : []), true), (!isMobile
                                    ? [
                                        {
                                            label: 'Historique',
                                            valueUnder: true,
                                        },
                                    ]
                                    : []), true) }), !isMobile ? (_jsx(TimelineVertical, { Model: "Client", ModelId: ClientId })) : (_jsx(_Fragment, {}))] })), _jsxs(Grid, __assign({ item: true, xs: 12, md: 8 }, { children: [_jsx(Tabs, __assign({ variant: "scrollable", allowScrollButtonsMobile: true, value: navigationSelected, onChange: function (e, newValue) { return setNavigationSelected(newValue); } }, { children: TABS.map(function (tab) { return (_jsx(Tab, { label: tab.label }, tab.label)); }) })), !isMobile && recapitulatifs.length ? (_jsx(Grid, __assign({ container: true }, { children: recapitulatifs.map(function (recapitulatif) { return (_jsx(Grid, __assign({ item: true, xs: 12, md: 12 / recapitulatifs.length }, { children: _jsx(ChartPie, { titre: recapitulatif.Label, datas: recapitulatif.Values, half: true }) }), recapitulatif.Label)); }) }))) : (_jsx(_Fragment, {})), TABS[navigationSelected].component()] }))] })) })));
    };
    var handleClickNote = function (newNote) { return __awaiter(void 0, void 0, void 0, function () {
        var isOk;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceClient.postNoteClient(ClientId, newNote)];
                case 1:
                    isOk = (_a.sent()).isOk;
                    if (isOk) {
                        getData();
                        Snackbar({ message: 'Note mise à jour avec succès' });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes vous sûr de vouloir supprimer le client ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceClient.deleteClient(ClientId)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderSuppressions = function () {
        if (client.IsLectureSeule) {
            return;
        }
        return (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsx(Stack, __assign({ direction: "row", justifyContent: "center", alignItems: "center", padding: 2 }, { children: _jsx(Button, __assign({ color: "error", onClick: function () { return handleClickDelete(); }, startIcon: _jsx(DeleteIcon, {}) }, { children: "Supprimer le client" })) })) })));
    };
    var renderTitle = function () {
        return (_jsx(CardTitle, { withFileAriane: true, datas: {
                ClientId: client.IdClient,
                ClientName: client.getLibelle.length > 50
                    ? client.getLibelle.substring(0, 47) + '...'
                    : client.getLibelle,
            }, color: "client", startIcon: _jsx(ClientIcon, {}), renderButtons: function () { return (_jsxs(_Fragment, { children: [!!client.IsLectureSeule && (_jsx(Tooltip, __assign({ disableInteractive: true, title: client.IsLectureSeule }, { children: _jsx(Chip, { color: "error", label: "Client non modifiable" }) }))), _jsxs(Stack, __assign({ direction: isMobile ? 'column' : 'row', spacing: 2, alignItems: isMobile ? 'center' : 'end' }, { children: [_jsx(Rating, { value: client.Note, onChange: function (e, newValue) { return handleClickNote(newValue); }, disabled: !!client.IsLectureSeule }), _jsxs(Stack, __assign({ direction: "row", spacing: 2 }, { children: [_jsx(Chip, { sx: classChipInHeader(), color: client.Actif ? 'success' : 'error', label: client.Actif ? 'Actif' : 'Désactivé' }), _jsx(Chip, { sx: classChipInHeader(), color: colorEtatClient(client.Etat), label: client.getEtatLibelle }), _jsx(Chip, { sx: classChipInHeader(), color: "secondary", label: client.IsSociete ? 'Professionnel' : 'Particulier' })] })), !client.IsLectureSeule && (_jsx(_Fragment, { children: _jsx(EditionClient, { ClientId: client.IdClient, onChange: function () { return getData(); } }) }))] }))] })); } }));
    };
    var TABS = [
        {
            label: 'Affaires',
            component: function () { return (_jsx(Affaire, { ClientId: ClientId, CanAddAffaire: !client.IsLectureSeule })); },
            show: true,
        },
        {
            label: 'Activités',
            component: function () { return _jsx(Activite, { ClientId: ClientId }); },
            show: true,
        },
        {
            label: 'Contacts',
            component: function () { return (_jsx(Contact, { ClientId: ClientId, CanEditClient: !client.IsLectureSeule })); },
            show: true,
        },
        {
            label: 'Équipe',
            component: function () { return (_jsx(Equipe, { ObjetId: ClientId, ObjetType: TYPES_EQUIPE.CLIENT, CanEditEquipe: !client.IsLectureSeule })); },
            show: originalUser.Licence.UseVision,
        },
        {
            label: 'Documents',
            component: function () { return (_jsx(Document, { Model: "Client", ModelId: ClientId, CanEditDocument: !client.IsLectureSeule })); },
            show: originalUser.Licence.UseDocument,
        },
    ].filter(function (tab) { return tab.show; });
    return (_jsxs(_Fragment, { children: [renderTitle(), renderClient(), renderSuppressions()] }));
};
//# sourceMappingURL=FicheClient.js.map